import React from "react";
import Success from "../../assets/icons/success.png";
import Error from "../../assets/icons/error.png";
import Info from "../../assets/icons/info.png";
import Warning from "../../assets/icons/warning.png";
import { Box, Button, Stack, Typography } from "@mui/material";
import { AlertCircle, Info as InfoIcon, ShieldCheck } from "lucide-react";
import help_center from "../../assets/icons/help_center.svg";
import CallUsNow from "./CallUsNow";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";
import "./common.scss";
import { TAILWIND_SUCCESS_BUTTON_RING_CLASS } from "../helpers/constants";

const PlainAlertMessage = ({
  openPopup,
  type,
  message,
  onClose,
  buttons,
  onCloseFun,
  footer = true,
  isTailwindComponent = false,
}) => {
  const [open, setOpen] = React.useState(openPopup);
  const handleClose = () => {
    setOpen(false);
    onCloseFun();
  };
  return (
    <>
      <Box className="text-center">
        {onClose && (
          <Button
            className="modal-close-btn"
            onClick={handleClose}
            style={{
              position: "absolute",
              right: 0,
              top: 8,
              padding: 0,
              margin: 0,
              background: "transparent",
            }}
          >
            <CloseIcon sx={{ color: "#9CB8A6" }} />
          </Button>
        )}

        <Box
          className={`my-3 ${isTailwindComponent ? "tailwind_component" : ""}`}
        >
          {isTailwindComponent ? (
            <>
              <div
                className={`mx-auto w-24 h-24 rounded-full flex items-center justify-center border-2 ${
                  type === "Success"
                    ? "bg-secondary/10 border-secondary/30"
                    : type === "Error"
                      ? "bg-destructive/10 border-destructive/30"
                      : type === "Warning"
                        ? "bg-amber-500/10 border-amber-500/30"
                        : "bg-muted/30 border-border"
                }`}
              >
                <div
                  className={`w-20 h-20 rounded-full flex items-center justify-center ${
                    type === "Success"
                      ? "bg-secondary"
                      : type === "Error"
                        ? "bg-destructive"
                        : type === "Warning"
                          ? "bg-amber-500"
                          : "bg-muted"
                  }`}
                >
                  {type === "Success" ? (
                    <ShieldCheck
                      className="w-10 h-10 text-white"
                      strokeWidth={3}
                    />
                  ) : type === "Error" ? (
                    <AlertCircle
                      className="w-10 h-10 text-white"
                      strokeWidth={3}
                    />
                  ) : type === "Info" || type === "Confirmation" ? (
                    <InfoIcon
                      className="w-10 h-10 text-white"
                      strokeWidth={3}
                    />
                  ) : type === "Warning" ? (
                    <AlertCircle
                      className="w-10 h-10 text-white"
                      strokeWidth={3}
                    />
                  ) : null}
                </div>
              </div>

              <p className="text-center fw-600 m-0 mt-4 text-2xl text-foreground">
                {type}
              </p>

              <Typography className="text-center fw-400 m-0 px-2 mt-2 text-muted-foreground">
                {message}
              </Typography>

              <Box className="my-4 alert-modal-btn tailwind_component plain-alert-message ">
                {onClose &&
                  !buttons &&
                  (type === "Error" ? (
                    <Button
                      className="popup_Btn error_popup_btn mx-auto max-w-xs !rounded-full"
                      onClick={handleClose}
                    >
                      OK, CLOSE
                    </Button>
                  ) : (
                    <Button
                      className={`${TAILWIND_SUCCESS_BUTTON_RING_CLASS} mx-auto max-w-xs`}
                      onClick={handleClose}
                    >
                      OK, ALL GOOD
                    </Button>
                  ))}

                <div className="tailwind_component plain-alert-message">
                  {buttons && buttons}
                </div>
              </Box>
            </>
          ) : (
            <>
              {type === "Success" && (
                <img className="popup_icon" src={Success} alt={type} />
              )}
              {type === "Error" && (
                <img className="popup_icon" src={Error} alt={type} />
              )}
              {(type === "Info" || type === "Confirmation") && (
                <img className="popup_icon" src={Info} alt={type} />
              )}
              {type === "Warning" && (
                <img className="popup_icon" src={Warning} alt={type} />
              )}
              <p className="text-center fw-600 m-0 my-2 type_text">{type}</p>
              <Typography className="text-center fw-400 m-0 px-2">
                {message}
              </Typography>
              <Box
                className={`my-4 alert-modal-btn ${
                  isTailwindComponent ? "tailwind-component" : ""
                }`}
              >
                {onClose &&
                  !buttons &&
                  (type === "Error" ? (
                    <Button
                      className={`popup_Btn error_popup_btn ${
                        isTailwindComponent ? "tailwind-component" : ""
                      }`}
                      onClick={handleClose}
                    >
                      ok, Close
                    </Button>
                  ) : (
                    <Button
                      className={`popup_Btn m-1 ${
                        isTailwindComponent
                          ? TAILWIND_SUCCESS_BUTTON_RING_CLASS
                          : "success_popup_btn"
                      }`}
                      onClick={handleClose}
                    >
                      ok, All Good
                    </Button>
                  ))}
                <div
                  className={`${
                    isTailwindComponent
                      ? "tailwind-component plain-alert-message"
                      : ""
                  }`}
                >
                  {buttons && buttons}
                </div>
              </Box>
            </>
          )}
        </Box>
      </Box>
      {footer && (
        <>
          <hr />
          <Stack direction={"row"} justifyContent="center" padding={2}>
            <img src={help_center} alt="help_center" className="me-1" />
            <span className="me-1">Having trouble?</span>
            <CallUsNow
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              renderText={
                <p className="text-blue text-decoration-none m-0 contact-support-link">
                  Contact support
                </p>
              }
            />{" "}
          </Stack>
        </>
      )}
    </>
  );
};

export default PlainAlertMessage;
